import { combineReducers } from 'redux'
import NotificationReducer from './NotificationReducer'
import UserReducer from './UserReducer'
import ProjectReducer from './ProjectReducer'
import RoleReducer from './RoleReducer'
import RegionReducer from './RegionReducer'

import TicketReducer from './TicketReducer'
import PaymentTypeReducer from './PaymentTypeReducer'
import ExhibitorReducer from './ExhibitorReducer'
import RaffleReducer from './RaffleReducer'
import SettingReducer from './SettingReducer'
import EventReducer from './EventReducer'

const RootReducer = combineReducers({
    notifications: NotificationReducer,
    user: UserReducer,
    project: ProjectReducer,
    role: RoleReducer,
    region: RegionReducer,
    ticket: TicketReducer,
    paymentType: PaymentTypeReducer,
    exhibitor: ExhibitorReducer,
    raffle: RaffleReducer,
    setting: SettingReducer,
    event: EventReducer,
})

export default RootReducer
